import RangeCalendar from 'rc-calendar/lib/RangeCalendar';
import styled from 'styled-components';

export const EstimatedRentalActivitiesWrapper = styled.div`
  display: flex;
  min-height: 300px;
  flex-direction: column;
  align-items: flex-start;
  font-family: 'Nunito Sans', sans-serif;
  border-radius: 10px;
  backdrop-filter: blur(10px);
  border: solid 1px #e6e6e9;
  background-color: rgba(255, 255, 255, 0.85);
  margin-bottom: 20px;
`;

export const Title = styled.div`
  display: flex;
  justify-content: flex-start;

  margin-top: 30px;
  margin-left: 20px;
  margin-right: 20px;
  height: 14px;
  font-size: 14px;
  font-weight: 700;
  color: #101938;
`;

export const Legend = styled.div.attrs({
  'aria-label':
    'Legend showing different colors for each reservation block on the calendar',
})`
  width: 30px;
  height: 30px;
  border-radius: 2px;
  background: linear-gradient(
    to bottom right,
    #e6ecfe 0%,
    #e6ecfe 50%,
    #adc6ff 50%,
    #adc6ff 100%
  );
  margin-top: 18px;

  :after {
    content: 'Booked';
    color: rgba(14, 26, 64, 0.45);
    font-weight: bold;
    font-family: 'Nunito Sans', sans-serif;
    margin-left: 40px;
    line-height: 30px;
  }
`;

export const CalendarWrapper = styled.div`
  display: flex;
  width: 574px;
  margin-left: 20px;
  margin-right: 20px;

  .rc-calendar-month-select,
  .rc-calendar-year-select {
    /*
      Functionality besides scrolling to the prior or next month is disabled.
      Clicking on a month doesn't bring up any controls related to the table, so
        pointer events are disabled to avoid confusing users.
    */
    pointer-events: none;
  }

  #left-change-month-btn-container,
  #right-change-month-btn-container {
    height: 100%;
    color: #152935;

    > button {
      position: absolute;
    }
  }

  #left-change-month-btn-container {
    > button {
      left: 0;
    }
  }

  #right-change-month-btn-container {
    > button {
      right: 0;
    }
  }
`;

export const StyledRangeCalendar = styled(RangeCalendar)`
  width: 100%;
  border: none;
  box-shadow: none;
  overflow: visible;
  font-family: 'Nunito Sans';

  .rc-calendar-date-panel {
    display: flex;
    justify-content: space-between;
  }

  .rc-calendar-range-part {
    width: 50%;
  }

  .rc-calendar-header {
    padding: 0px;

    > div {
      display: flex;
      justify-content: center;
      width: 100%;
    }
  }

  .rc-calendar-column-header {
    font-weight: bold;
    font-size: 9px;
  }

  .rc-calendar-body {
    height: 100%;
    border-bottom: none;
  }

  .rc-calendar-prev-year-btn,
  .rc-calendar-prev-month-btn,
  .rc-calendar-next-year-btn,
  .rc-calendar-next-month-btn,
  .rc-calendar-next-month-btn-day {
    display: none;
  }

  .rc-calendar-last-month-cell {
    visibility: hidden;
  }

  .rc-calendar-month-select,
  .rc-calendar-year-select {
    color: #152935;
  }
`;

export const DateCellWrapper = styled.div`
  display: flex;
  min-width: 35px;
  max-width: 38px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 38px;
  margin-top: 4px;
  margin-bottom: 4px;
  background-color: ${(props) => props.backgroundColor};

  .date-cell-date {
    font-weight: bold;
    font-size: ${(props) => (props.hasRate ? '12px' : '10px')};
    color: ${(props) =>
      props.hasRate && !props.isBlocked ? 'inherit' : 'rgba(0, 0, 0, 0.35)'};
  }

  svg {
    opacity: ${(props) => props.isBlocked && '35%'};
  }
`;
